$(document).ready(function(){
  $(".ing-list span").click(function(){
    var cId = $(this).attr("data-popup");
    $("#" + cId).addClass("popup-enabled")
  })
   $(".close-btn").click(function(){
   $(this).parent(".ingrediant-popup").removeClass("popup-enabled")
  })

$(document).on("click", ".close-btn", function(){
  // Close large ingredient popup
  $(this).closest(".ingrediant-popup").removeClass("popup-enabled");
  
  // Close small popup
  $(this).closest(".small-popup").fadeOut();
});

   $(".tabdes").hide();

  $(".ptab").click(function () {
    var cTab = $(this).attr("data-tab");
    var content = $("#" + cTab);

    // If the clicked tab is already active and visible — hide it and remove active
    if ($(this).hasClass("active") && content.is(":visible")) {
      content.slideUp();
      $(this).removeClass("active");
    } else {
      // Otherwise, hide others, show this one, update active classes
      $(".tabdes").slideUp();
      content.slideDown();
      $(".ptab").removeClass("active");
      $(this).addClass("active");
    }
  });
$(document).on('click', '.full-list-show', function(e) {
  e.preventDefault();

  var currentfulllist;

  // For duo/bundle pages: use the hardcoded data-full-list directly
  if ($(this).attr('id') !== 'ingredient-list-btn') {
    currentfulllist = $(this).attr('data-full-list');
  } else {
    // For individual product pages: read variant ID from URL, look up handle from map
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');
    if (variantId && window.variantIngredientMap && window.variantIngredientMap[variantId]) {
      currentfulllist = window.variantIngredientMap[variantId];
    } else {
      // Fallback: use whatever is on the button (first variant, set at page load)
      currentfulllist = $(this).attr('data-full-list');
    }
  }

  $("#" + currentfulllist).addClass("popup-enabled").siblings().removeClass("popup-enabled");

  var target = $(this).attr('href');
  if (target && $(target).length) {
    $('html, body').animate({ scrollTop: $(target).offset().top }, 800);
  }
});


   $(document).on('click', '.ing', function(e) {
   var csmall = $(this).attr("data-popup");
   console.log("Clicked ingredient:", csmall); // Debug line
   $("#"+csmall).fadeIn().siblings(".small-popup").fadeOut();
});

$(document).on("click", ".swatch-input__label", function(){
    var curvig = $(this).attr("data-anchor");
    $("#tab-" + curvig).show().siblings(".tabdes").hide();
    $(".ig-tab").attr("data-tab", "tab-" + curvig);
    $(".full-list-show").attr("data-full-list", curvig);
});




 var swiper = new Swiper(".igswiper", {
     pagination: {
        el: ".swiper-pagination",
        clickable: true,

      },
    });

  
})

// Watch for URL changes caused by variant selection (Dawn updates URL via history.replaceState)
(function() {
  var lastVariantId = null;

  function syncIngredientBtn() {
    if (!window.variantIngredientMap) return;
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');
    if (variantId && variantId !== lastVariantId) {
      lastVariantId = variantId;
      var handle = window.variantIngredientMap[variantId];
      if (handle) {
        $('.full-list-show#ingredient-list-btn').attr('data-full-list', handle);
      }
    }
  }

  // Poll for URL changes (replaceState doesn't fire any event)
  setInterval(syncIngredientBtn, 300);
})();
